import { selectUser } from './selectUser';
import { TApplicationState } from '../../types/redux';

export const selectUserPhone = (state: TApplicationState) => {
  const user = selectUser(state);
  const phone = user.isAuthenticated && user.phones[0]?.phone;

  return phone || null;
};

export const selectUserPhoneConfirmed = (state: TApplicationState) => {
  const user = selectUser(state);
  const phone = user.isAuthenticated && user.phones[0]?.confirmed;

  return phone || null;
};
